// extracted by mini-css-extract-plugin
export default {"favorites":"favorites_favorites__-bBIL","addAll":"favorites_addAll__B2fOX"};